import { createFileRoute, notFound } from "@tanstack/react-router";
import LeistungDetailPage from "@/pages/LeistungDetailPage";
import NotFound from "@/pages/NotFound";
import { buildRouteHead } from "@/lib/route-head";
import { services } from "@/data/services";
import {
  breadcrumbSchema,
  serviceSchema,
  courseSchema,
  faqSchema,
} from "@/lib/schema";

export const Route = createFileRoute("/leistungen/$slug")({
  // Ohne echten 404-Status werten Google & Co. unbekannte Slugs als Soft-404.
  loader: ({ params }) => {
    if (!services.some((s) => s.slug === params.slug)) {
      throw notFound();
    }
  },
  notFoundComponent: NotFound,
  head: ({ params }) => {
    const service = services.find((s) => s.slug === params.slug);
    if (!service) {
      return buildRouteHead({
        title: "Leistung nicht gefunden | Enno & Jens",
        description: "Diese Leistung existiert nicht. Zur Übersicht aller Leistungen.",
        path: `/leistungen/${params.slug}`,
        noIndex: true,
      });
    }
    const imageBase = service.image ?? "/images/services/webdesign";
    const image = `${imageBase}-1024.webp`;
    const path = `/leistungen/${service.slug}`;
    const scripts = [
      serviceSchema({
        name: service.title,
        description: service.description,
        path,
        image,
        serviceType: service.title,
      }),
      ...(service.packages && service.packages.length
        ? [
            courseSchema({
              name: service.heroTitle,
              description: service.answerFirst ?? service.description,
              path,
              image,
              modes: service.packages.map((pkg) => ({
                name: `${service.heroTitle} – ${pkg.name}`,
                duration: pkg.duration,
              })),
            }),
          ]
        : []),
      breadcrumbSchema([
        { name: "Startseite", path: "/" },
        { name: "Leistungen", path: "/leistungen" },
        { name: service.title, path },
      ]),
      ...(service.faq && service.faq.length ? [faqSchema(service.faq)] : []),
    ];

    return buildRouteHead({
      title: `${service.heroTitle} | Agentur Wernigerode`,
      description: `${service.description} ✓ Professionelle ${service.title} aus Wernigerode im Harz. Jetzt unverbindlich anfragen!`,
      path,
      image,
      imageAlt: `${service.title} von Enno & Jens`,
      imageWidth: 1024,
      imageHeight: 730,
      scripts,
    });
  },
  component: LeistungDetailPage,
});
